export type EquityNotifRowVariant = 'warning' | 'info' | 'secondary';

function isCompletedNotification(title: string): boolean {
  const t = (title || '').toLowerCase();
  return (
    t.includes('completad') ||
    t.includes('aceptad') ||
    t.includes('activa') ||
    t.includes('registrad')
  );
}

export function getIncentivesMarketNotificationVariant(
  title: string
): EquityNotifRowVariant {
  const t = (title || '').toLowerCase();
  if (
    t.includes('pago') ||
    t.includes('documentación pendiente') ||
    t.includes('acción requerida')
  ) {
    return 'warning';
  }
  if (
    t.includes('documentación') ||
    t.includes('nueva documentación') ||
    t.includes('comentario') ||
    isCompletedNotification(title)
  ) {
    return 'info';
  }
  return 'secondary';
}

export function getIncentivesMarketNotificationIcon(
  variant: EquityNotifRowVariant,
  title: string
) {
  if (isCompletedNotification(title)) {
    return 'ni-check-circle';
  }

  switch (variant) {
    case 'warning':
      return 'ni-cc-alt2';
    case 'info':
      return 'ni-file-docs';
    default:
      return 'ni-offer';
  }
}
